SupportUtilsHelper = require('../../support/frontend/helpers/utils')
SupportAPIHelper = require('../../support/frontend/helpers/API')
SharedUtilsHelper = require('../../shared/frontend/helpers/utils')
web2018SharedHelper = require('../helpers/shared')
LocalizedRoutes = require('./localized_routes')
queryString = require 'qs'

KEY_FOR_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

module.exports =

  setReasonText: (contactChannelParams) ->
      data = {}
      category = contactChannelParams.dropdownCategory
      SubCategory = contactChannelParams.dropdownSubcategory
      title = contactChannelParams.title
      categoryId = contactChannelParams.primaryCategoryId
      articleId = contactChannelParams.contentId
      if category? && SubCategory?
         data.reasonId = SubCategory
         data.reasonText = SubCategory
         data.reasonTitle = title
         data.parentCategoryText = category
         data.categoryId = category
         data.articleId = articleId
      else
        if contactChannelParams.selectedItem?.isCostcoDeal
          data.reasonId = "costco_faq"
          data.reasonText = I18n.translate('js.modules.support.costco_faq')
          data.parentCategoryId = "costco_faq"
          data.parentCategoryText = I18n.translate('js.modules.support.costco_faq')
        else
          data.reasonId = "direct_email_ticket_subcategory"
          data.reasonText = I18n.translate('js.modules.support.default_reason')
          data.parentCategoryId = "direct_email_ticket"
          data.parentCategoryText = I18n.translate('js.modules.support.default_parent_category')
      return data

  getDealType: (dealType) ->
    web2018SharedHelper.getDealType(dealType)

  getBasicTicketData: (data, order) ->
      currentUser = order?.user
      emailBasicData =
        reason: data.reasonId
        reason_id: data.reasonId
        reason_text: data.reasonText
        reason_group: data.reasonGroup
        parent_category: data.parentCategoryId
        parent_category_text: data.parentCategoryText
        order_id: order?.order_id || data.order_id
        category_id: data.categoryId
        article_id: data.articleId
        escalate_to_merchant: order?.escalateToMerchantFlag
        user_name: currentUser?.firstName
        user_email: currentUser?.email
        user_status: currentUser?.status
        guest_checkout: data.isGuestCheckoutFlow

      emailBasicData


  getClaimInfo: (claim) ->
      claimData =
        claim_id: claim?.claimId
        deal_id: claim?.dealId
        is_clo_deal: claim?.transactions?.dealType is 'CLO' ? true : false
        transaction_id: claim?.transaction_id
      claimData.currentClaim =
        claimId: claim?.claimId
        dealId: claim?.dealId
        is_clo_deal: claim?.transactions?.dealType is 'CLO' ? true : false
        transactionId: claim?.transaction_id
      claimData

  createTicket: (data, renderSuccess, renderError) ->
    url = "#{Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/ticket/create"
    method = "POST"
    SupportAPIHelper.call url, method, data, renderSuccess, renderError, false


  renderSuccess: (response) ->
    # Save data to sessionStorage
    if response && response.sessionToken
      sessionStorage.setItem('inbentaSessionKey', response.sessionToken);

  renderError: () ->
    # do nothing

  createSession: () ->
    url = "#{Groupon.Utils.getConfigFromDom().FAQBASEURL}/session"
    SupportAPIHelper.get url,null, @renderSuccess, @renderError, false

  errorCb: () ->
    #Do Nothing

  successCb: (response) ->
    #Do Nothing

  createClickEventInbenta: (clickCode) ->
    if not clickCode
      return
    inbentaSessionToken = sessionStorage.getItem 'inbentaSessionKey'
    if not inbentaSessionToken
       @createSession()
       return
    url = "#{Groupon.Utils.getConfigFromDom().FAQBASEURL}/event"
    method = "POST"
    body = {
      sessionToken: inbentaSessionToken,
      type: "click",
      data: {
        code: clickCode
      }
    }
    SupportAPIHelper.call(url, method, body, @successCb, @errorCb, false)

  createCallbackTicket: (data, order, renderSuccess, renderError) ->
    country_code = order?.deal?.division?.countryCode
    if !country_code
      country_code = data.locale.substr(3)
    deal_type = order?.DEAL_TYPE;
    method = "POST"
    url = "#{Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/hold_time/create?country_code=#{country_code}"
    if deal_type
      url += "&deal_type=#{deal_type}"
    SupportAPIHelper.call url, method, data, renderSuccess, renderError, false

  getQueryStringForFAQToContactChannels: (selectedInbentaResult, options) ->
    qs = ""
    if selectedInbentaResult?
      selectedInbentaResult = _.omit(selectedInbentaResult, 'clickCode')
      qs = queryString.stringify(_.extend({showContactChannels: true}, selectedInbentaResult), options)
    qs

  canSkipLogIn: (configFromDom, selectedInbentaResult) ->
    inbentaConfig = configFromDom.inbentaNonSignInItems
    articles = inbentaConfig.articles
    if articles
      for articleIdFromConfig in articles
        if(articleIdFromConfig is parseInt(selectedInbentaResult.contentId))
          return true
    categories = inbentaConfig.categories
    if categories
      for categoryIdFromConfig in categories
        if(categoryIdFromConfig is selectedInbentaResult.primaryCategoryId)
          return true
    return false
  
  showGuestHelpOptions: (article) ->
    configFromDom = Groupon.Utils.getConfigFromDom()
    if configFromDom
      return !configFromDom.user and !@canSkipLogIn(configFromDom, article) and configFromDom.guestCheckoutEnabledInWeb
    return false

  getDateStringWithDay: (dateString = "") ->
    dateObject = new Date(dateString)
    if dateObject isnt "Invalid Date"
      dayIndex = dateObject.getDay()
      if dayIndex > -1 and dayIndex < 7
        day = I18n.translate("js.modules.web_2018.days.#{KEY_FOR_DAYS[dayIndex]}")
        return "#{day}, #{dateString}"
    dateString

  isFeatureFlagEnabled: (featureFlag) ->
    try
      featureFlagObject = JSON.parse(Groupon.Utils.getConfigFromDom().featureFlagJSON)
    catch
      featureFlagObject = {}
    featureFlagObject?[featureFlag]

  isExperimentEnabled: (experiment) ->
    try
      experimentsObject = JSON.parse(Groupon.Utils.getConfigFromDom().experiments)
    catch
      experimentsObject = {}
    experimentsObject?[experiment]

  isMarketPlaceOrder: (order) ->
    ( (@isFeatureFlagEnabled('treatMarketplaceDifferent')) and
    !(SharedUtilsHelper.evaluate(order?.deal?.isSellerOfRecord)) and
    (order?.dealOption?.inventoryService?.id is 'goods') )

  getCSRoute: (url) ->
    matchedURL = null
    _.each LocalizedRoutes.cs, (csRoute) =>
      if url.includes("/#{csRoute}")
        matchedURL = url.replace(csRoute, "customer_support")
        matchedURL = /.*?(\/customer_support.*)/.exec(matchedURL)[1]
    matchedURL

  getFAQRoute: (url) ->
    matchedURL = null
    _.each LocalizedRoutes.faq, (faqRoute) =>
      if url.includes("/#{faqRoute}")
        matchedURL = url.replace(faqRoute, "faq")
        matchedURL = /.*?(\/faq.*)/.exec(matchedURL)[1]
    matchedURL

  getActualURL: (url) ->
    matchedURL = null
    matchedURL = @getCSRoute(url)
    return matchedURL if matchedURL?
    matchedURL = @getFAQRoute(url)
    return matchedURL if matchedURL?
    url
  
  readCookie: (name) ->
    encodedName = encodeURIComponent('cs_' + name) + '='
    cookiesSplit = document.cookie.split(';')
    findCookie = (e) -> e.trim().indexOf(encodedName) >= 0
    val = cookiesSplit.find(findCookie)
    return if val then decodeURIComponent(val.trim().split(encodedName)[1]) else null

  setCookie: (name, value, days) ->
    if !name
      return false
    value = value or ''
    expires = ''
    if days
      date = new Date
      date.setTime date.getTime() + days * 24 * 60 * 60 * 1000
      expires = '; expires=' + date.toGMTString()
    document.cookie = encodeURIComponent('cs_' + name) + '=' + encodeURIComponent(value) + expires + '; path=/'
    return true

